import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { YearProvider } from './contexts/YearContext'
import './index.css'
import { isChunkLoadError, reloadOnceForChunkError } from './utils/gate'

// После выкладки у файлов новые имена: если вкладка просит старый чанк, один раз перезагружаем страницу.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  reloadOnceForChunkError()
})
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) reloadOnceForChunkError()
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <YearProvider>
          <BrowserRouter>
            <App />
            <Toaster 
              position="bottom-center"
              toastOptions={{
                duration: 2000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </BrowserRouter>
        </YearProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
